// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { AufgabePromptDaten, type Prompt } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type CreateAufgabeInboundPromptQuery = { activate?: boolean };

export function useCreateAufgabeInboundPrompt(): (
  aufgabeId: string,
  query: CreateAufgabeInboundPromptQuery,
  requestBody: AufgabePromptDaten
) => Promise<Prompt> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, query = {}, requestBody) =>
      (await getAPI()).prompts.createAufgabeInboundPrompt({
        aufgabeId,
        ...query,
        requestBody,
      }),
    [getAPI]
  );
}
